import React, { useEffect } from 'react';
import { useAuth } from '../../context/useAuth';
import { useTeamStore } from '../../lib/store/teamStore';
import { TeamList } from '../../components/teams/TeamList';
import InvitationsWidget from '../../components/dashboard/InvitationsWidget';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();
  const { fetchUserTeams } = useTeamStore();
  
  useEffect(() => {
    fetchUserTeams();
  }, [fetchUserTeams]);
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-6">
        Welcome, {user?.user_metadata?.full_name || 'User'}
      </h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="md:col-span-2">
          <TeamList />
        </div>
        <div>
          <InvitationsWidget />
        </div>
      </div>
    </div>
  );
};

export default DashboardPage; 